/**
 * EmbeddedTerasuAnswerPage — モバイル WebView 用の GBなび 週次回答フロー
 *
 * モバイルの GBなびタブから /embed/terasu/answer?embedded=1&lang=xx で開かれる。
 * Web の TerasuAnswerFlow（固定→ネガティブ時のみ深掘り→テーマ→送信）をそのまま利用し、
 * 完了時にネイティブへ ANSWER_DONE を送る（ネイティブが WebView を閉じて GBなびタブへ戻す）。
 * 表示言語は EmbeddedShell が ?lang= を i18n / localStorage に適用済み。
 */
import React from 'react';
import { TerasuAnswerFlow } from '../terasu';
import { notifyAnswerDone } from '../../shared/api/embeddedAuth';

export const EmbeddedTerasuAnswerPage: React.FC = () => {
  return <TerasuAnswerFlow onComplete={() => notifyAnswerDone()} />;
};

export default EmbeddedTerasuAnswerPage;
